import React from 'react';

import { getXSRFToken } from '../../util/server-util';

export default function HiddenXSRF() {
  const xsrf = getXSRFToken();
  return <input type='hidden' name='_xsrf' value={xsrf} />;
}
